"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.402 7.967c-.058 5.07-.243 10.54-.334 12.998-.03.8-.566 1.47-1.366 1.513a12.895 12.895 0 0 1-1.404 0c-.8-.044-1.336-.712-1.366-1.513-.09-2.458-.276-7.928-.334-12.998l-2.22 1.811c-.476.388-1.122.543-1.646.224a3.18 3.18 0 0 1-.616-.483 3.23 3.23 0 0 1-.48-.636c-.31-.53-.152-1.178.257-1.636 1.883-2.103 4.311-4.214 6.009-5.378.677-.464 1.542-.507 2.229-.058 1.697 1.111 4.107 3.32 5.978 5.435.407.46.564 1.106.255 1.637a3.231 3.231 0 0 1-.48.636c-.195.2-.41.358-.616.483-.524.319-1.17.164-1.646-.224l-2.22-1.811Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgArrowUp);
var _default = exports["default"] = Memo;